import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Label } from 'flowbite-react';
import FilterSelect from '../../../shared/FilterSelect';
import { PrettoSlider } from 'src/components/recruiterPositions/RecruiterCandidatesFilters';
import { debounce } from 'lodash';

export const salaryOptions = [
	{ value: 'low', label: '0 to 3.5 LPA', data: { min: 0, max: 3.5 } },
	{ value: 'medium', label: '3.5 to 5 LPA', data: { min: 3.5, max: 5 } },
	{ value: 'average', label: '5 to 10 LPA', data: { min: 5, max: 10 } },
	{ value: 'above_average', label: '10 to 12 LPA', data: { min: 10, max: 12 } },
	{ value: 'high', label: '12 to 15 LPA', data: { min: 12, max: 15 } },
	{ value: 'extreme', label: '15 to 20 LPA', data: { min: 15, max: 20 } },
];

const SalaryFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const salary = JSON.parse(searchParams.get('salary') || '[]');

	// Debounce function for updating salary in URL
	const debouncedSetSearchParams = useCallback(
		debounce((newValue: number[]) => {
			searchParams.set('salary', JSON.stringify([`${newValue[0]}_${newValue[1]}`]));
			setSearchParams(searchParams);
		}, 500), // 500ms delay
		[searchParams, setSearchParams],
	);

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!salary?.length}
					placeholder={'Salary'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[285px] dark:bg-[#1F2A37] py-2 px-7 ml-auto flex h-[110px] items-center justify-center">
							<PrettoSlider
								min={1}
								max={40}
								defaultValue={[1, 40]}
								marks={[
									{ value: 1, label: '1 LPA' },
									{ value: 40, label: '40 LPA' },
								]}
								value={salary.length ? salary[0].split('_').map(Number) : [1, 40]}
								onChange={(e: Event, newValue: number | number[]) => {
									if (!Array.isArray(newValue)) return;
									// Use the debounced version of setSearchParams
									debouncedSetSearchParams(newValue);
								}}
								valueLabelDisplay="auto"
							/>
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Salary</Label>
					<div className="min-w-[285px]  dark:bg-[#1F2A37] py-2 px-6 ml-auto mt-2">
						<PrettoSlider
							min={1}
							max={40}
							defaultValue={[1, 40]}
							marks={[
								{ value: 1, label: '1 LPA' },
								{ value: 40, label: '40 LPA' },
							]}
							value={salary.length ? salary[0].split('_').map(Number) : [1, 40]}
							onChange={(e: Event, newValue: number | number[]) => {
								if (!Array.isArray(newValue)) return;
								// Use the debounced version of setSearchParams
								debouncedSetSearchParams(newValue);
							}}
							valueLabelDisplay="auto"
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default SalaryFilterInput;
